import styled from "styled-components";
import { Field } from "formik";

export const InputStyled = styled(Field)`
  -moz-appearance: textfield; //hide arrows in firefox
  background-color: transparent;
  border: 1px solid
    ${({ theme, $error }) =>
      $error ? theme.colors.danger : theme.colors.input.border};
  color: ${({ theme }) => theme.colors.info.secondary};
  font: ${({ theme }) =>
    `${theme.font.size.smallCalc} ${theme.font.family.primary}`};
  margin: 0.5rem 0 0;
  height: 40px;
  min-height: 40px;
  width: 100%;
  min-width: 100%;
  padding: 0 20px;
  border-radius: 5px;
  box-sizing: border-box;

  &::placeholder {
    color: ${({ theme }) => theme.colors.info.secondary};
  }

  &::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  option {
    background-color: ${({ theme }) => theme.colors.bg.primary};
  }
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 1vh 0;
  position: relative;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.font.size.small};
  font-weight: 600;
  padding-left: 5px;
`;

export const ErrorText = styled.div`
  bottom: -5px;
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => theme.font.size.xSmall};
  position: absolute;
`;
